import type { ImportScope } from '@sflx/shared';

/** The playback screen for a public playlist. A custom one is named by its account, never by its address. */
export function playlistWatchPath(scope: ImportScope, accountId: string): string {
  return scope === 'custom'
    ? `/free/playlist?scope=custom&account=${encodeURIComponent(accountId)}`
    : `/free/playlist?scope=${scope}`;
}
